

import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import ServiceProviderChip from './ServiceProviderChip.vue';
import ChipMixin from "@/components/shared/chips/ChipMixin";

@Component({
  mixins: [ChipMixin,],
})
export default class ServiceProviderTypeChip extends ServiceProviderChip {

  @Prop()
  protected item!: IShortServiceProvider;
  @Prop({ default: false })
  protected withCaption!: boolean;

  protected get getColor(): string {
    return this.getDeletedAt ? 'secondary' : (this.item||{}).color;
  }

  protected get typeText(): any {
    return this.$t('services.provider.fields.type.values.' + (this.item||{}).type);
  }

}

